/**
 * safeguardErrorMsg function safeguards against the error not being a string
 * @param error
 * @returns string | null
 */

export const safeguardErrorMsg = (error: any) => {
  if (typeof error === 'string') {
    return error;
  }
  return null;
};
